import { updateProcurementItem } from '../State/procurementItems';
import { addDeletedProcurementItemId } from '../State/deletedProcurementItemIds';

export default (item) => (dispatch) => {
    // Mark as pending delete in UI - item stays visible until Save Changes
    dispatch(updateProcurementItem({ ...item, _pendingDelete: true }));

    // If it has a real DB ID (not a temp _new_ item), queue it for deletion on save
    if (typeof item.id !== 'string' || !item.id.startsWith('_new_')) {
        dispatch(addDeletedProcurementItemId(item.id));
    }
}
